<template>
    <div>
         <div style="display: flex; margin-top: 5px;">
            <!-- 日期选择器 -->
            <el-form :model="queryParams" label-width="120px">
                <el-form-item label="送货开始时间">
                    <el-date-picker size="small" clearable v-model="queryParams.beginTime" type="date" value-format="yyyy-MM-dd"
                        placeholder="选择送货开始时间" :picker-options="pickerStart">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="送货结束时间">
                    <el-date-picker size="small" clearable v-model="queryParams.endTime" type="date" value-format="yyyy-MM-dd"
                        placeholder="选择送货结束时间" :picker-options="pickerEnd">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <!-- 其他查询 -->
            <el-form :inline="true" class="demo-form-inline" label-width="120px" >
                <el-form-item label="提单号">
                    <el-input size="small" clearable v-model.trim="queryParams.blNo" placeholder="请输入提单号"
                        style="width: 100%;"></el-input>
                </el-form-item>
                <el-form-item label="委托单位">
                    <el-select size="small" filterable clearable v-model="queryParams.customer"
                        placeholder="请选择委托单位">
                        <el-option v-for="item in customerList" :key="item.id" :label="item.name"
                            :value="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="货物分类" >
                    <el-select size="small" filterable clearable v-model="queryParams.category"
                        placeholder="请选择货物分类">
                        <el-option v-for="item in categoryList" :key="item.id" :label="item.value"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div style="width: 300px;text-align: right;">
                <el-button  type="primary" @click="getData()" size="small">查询</el-button>
                <!-- <el-button size="mini" type="success" @click="add">添加</el-button> -->
                <el-button  type="warning" @click="exportExcel()" size="small">导出excel</el-button>
            </div>
        </div>
        <el-table  :data="tableData" size="small" style="margin-top: 0px;" ref="report-table">
            <el-table-column type="index" width="50"> </el-table-column>
            <el-table-column prop="blNo" label="提单号"> </el-table-column>
            <el-table-column prop="vessel" label="船名"> </el-table-column>
            <el-table-column prop="customer" label="委托单位"> </el-table-column>
            <el-table-column prop="csMan" label="单证"> </el-table-column>
            <el-table-column prop="category" label="货物分类"> </el-table-column>
            <el-table-column prop="containerNo" label="箱号"> </el-table-column>
            <!-- <el-table-column prop="containersInfo" label="集装箱"> </el-table-column> -->
            <el-table-column prop="incomeTotal" label="应收合计"> 
                <template slot-scope="scope">
                    <span v-format="'#,##0.00'">{{ scope.row.incomeTotal }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="payTotal" label="应付合计"> 
                <template slot-scope="scope">
                    <span v-format="'#,##0.00'">{{ scope.row.payTotal }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="balance" label="利润"> 
                <template slot-scope="scope">
                    <span v-format="'#,##0.00'">{{ scope.row.balance }}</span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
import req from '@/utils/index.js';
import url from '@/config/url1.js';
import url1 from '@/config/url2.js';
import ExcelJS from 'exceljs';
export default {
    data() {
        return {
           queryParams:{
                beginTime: '', //创建时间(开始)
                endTime: '', //创建时间(结束)
                blNo: '', //提单号
                customer: '',//委托单位
                category: '',//货物分类
            },
            categoryList:[],
            customerList:[],
            tableData:[],
            pickerStart:{
                disabledDate: time => { 
                // 如果有 结束 日期 要选择结束之前的日期
                    if(this.queryParams.endTime){
                        return (
                        // 结束日期 小于 开始日期（开始日期不能选择 结束日期之后的日期）
                        new Date(this.queryParams.endTime).getTime() < time.getTime() 
                        );
                    }else{
                        // 如果没有结束日期 那么都可以选
                        return false
                    }
                }
            },
            // 结束时间限制范围
            pickerEnd:{
                disabledDate: time => {
                    // 如果有开始日期 
                    if(this.queryParams.beginTime){
                        return (((new Date(this.queryParams.beginTime).getTime())-3600*24*1000)>(time.getTime()));
                    }else{
                        // 如果没有开始日期 都可以选择
                        return false
                    }
                }
            },
        }
    },
    mounted() {
        this.getcustomList()
        this.getClassOption()
        this.getData()
    },
    created() {
    },
    methods: {
        getData(){
            let URL = `${url1.singleContainerDebitNote}`;
            req.post(URL,this.queryParams).then(res => {
                if (res.data.code === 200) {
                    this.tableData = res.data.data;
                }
            })
        },
        //获取委托单位数据
        getcustomList() {
            let URL = `${url1.getList}/?name=${this.queryParams.customer}`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.customerList = res.data.data;
                }
            })
        },
         // 获取货物分类数据
        getClassOption() {
            let value = '货物分类';
            let URL = `${url.getDicList}/?value=${value}`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.categoryList = res.data.data.data;
                }
            })
        },
        async exportExcel(){
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet1');
            const columns = [
                { header: '提单号', key: 'blNo', width: 20 },
                { header: '船名', key: 'vessel', width: 20 },
                { header: '委托单位', key: 'customer', width: 20 },
                { header: '单证', key: 'csMan', width: 20 },
                { header: '货物分类', key: 'category', width: 20 },
                { header: '箱号', key: 'containerNo', width: 20 },
                // { header: '集装箱', key: 'containersInfo', width: 20 },
                { header: '应收合计', key: 'incomeTotal', width: 20 },
                { header: '应付合计', key: 'payTotal', width: 20 },
                { header: '利润', key: 'balance', width: 20 },
            ];
              // 设置表头
            worksheet.columns = columns;
             // 添加数据行
            this.tableData.forEach(item => {
                worksheet.addRow(item);
            });

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${this.getFormattedDateTime()}`;
            link.click();
            window.URL.revokeObjectURL(url);
        },
        getFormattedDateTime() {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
        },
    }
}
</script>
<style lang="css" scoped>
.el-form-item {
    margin-bottom: 0;
}
</style>